import ContactForm from "./ContactForm";
import Footer from "./Footer";
import Header from "./Header";

function AboutUs() {

    return (
        <>
            <div className="container-fluid px-5 py-2">
                <Header />
                <main>
                    <div className="container px-4 py-5">
                        <h2 className="fw-bold pb-2 text-center">About Us</h2>

                        <div class="row align-items-center">
                            <div class="col-md-12 mb-4 mb-md-0">
                                <p class="text-body-secondary">
                                    At <strong>decipherX</strong>, we are driven by a passion for simplifying complex tasks through intelligent automation.
                                    With deep expertise in artificial intelligence and machine learning, our focus is on delivering robust solutions in <strong>audio transcription </strong>
                                     and <strong>image CAPTCHA processing</strong> that empower businesses to operate more efficiently and securely.
                                </p>
                                <p class="text-body-secondary">
                                    Whether you're a startup or an enterprise, we aim to provide tools that are scalable, accurate, and easy to integrate—so you can
                                    focus on what matters most: your users.
                                </p>
                            </div>
                        </div>


                    </div>

                    <div className="container px-4 py-5" id="contactUs">
                        {/* <!-- Contact Section --> */}
                        <section class="py-5" id="contact">
                            <div class="container">
                                <div class="row text-center mb-5">
                                    <div class="col">
                                        <h2 class="fw-bold text-body-emphasis">Contact Us</h2>
                                        <p class="text-body-secondary">Have questions or need support? Reach out to our team—we're here to help.</p>
                                    </div>
                                </div>

                                <div class="row g-5">
                                    {/* <!-- Contact Info --> */}
                                    <div class="col-md-5">
                                        <h5 class="fw-bold mb-3">Get in Touch</h5>
                                        <p class="text-body-secondary">We typically respond within 24-48 hours. Feel free to email us, call us, or fill out the form.</p>
                                        <ul class="list-unstyled text-body-secondary">
                                            <li><strong>Email:</strong> <a href="mailto:SalesNSupport@decipherX.in">SalesNSupport@decipherX.in</a> </li>
                                            {/* <li><strong>Phone:</strong> +91-63602-88933</li> */}
                                            <br />
                                            <li><strong>Address:</strong><br /> C-25, Samrajya Society - 1, Mujmahuda Road, Akota, Vadodara, Gujarat, 390020, India</li>
                                        </ul>
                                    </div>

                                    {/* <!-- Contact Form --> */}
                                    <ContactForm />
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
            </div>
            <div className="container py-3" style={{ maxHeight: "241px" }}>
                <Footer />
            </div>
        </>
    );
}

export default AboutUs;